import CheckHands from "./checkHandsContainer";
export default CheckHands;
